import { defineStore, acceptHMRUpdate } from 'pinia';
import useUndoRedoStore from '@/stores/undoredo';
import usePlanningStore from './planning';

let undoState = {};

function undoredoMeta() {
  const planningStore = usePlanningStore();
  const { planning } = planningStore;
  if (angular.equals(planning.meta, undoState)) return;
  const newState = angular.copy(planning.meta);
  const oldState = angular.copy(undoState);

  useUndoRedoStore().add({
    action: () => {
      planning.meta.set(angular.copy(newState));
    },
    rollback: () => {
      planning.meta.set(angular.copy(oldState));
    },
  });
  planningStore.save();
}

const store = defineStore('planning-meta', {
  actions: {
    startChangingMeta() {
      const { planning } = usePlanningStore();
      undoState = angular.copy(planning.meta);
    },
    changingMeta() {
      const { planning } = usePlanningStore();
      if (! angular.equals(planning.meta, undoState)) {
        undoredoMeta();
      }
    },
  },
});

if (import.meta.hot) import.meta.hot.accept(acceptHMRUpdate(store, import.meta.hot));
export default store;
